import Swiper from "swiper";

export default function () {
    const slidersList = document.querySelectorAll('.editor-slider');

    slidersList.forEach((slider) => {

       new Swiper('.editor-slider .swiper-container', {
            loop: true,
            navigation: {
                nextEl: '.button-next',
                prevEl: '.button-prev',
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
        });
    });
}